import React from 'react'
import Helmet from 'react-helmet'

import Layout from '../components/layout'
import Gallery from '../components/Gallery'


import cryptoCurrencyApp from '../assets/images/projects/cryptocurrency.jpg'
import davidGraham from '../assets/images/projects/davidgraham.jpg'
import pokedex from '../assets/images/projects/pokedex.jpg'
import artisanFlooring from '../assets/images/projects/artisanflooring.jpg'

const DEFAULT_IMAGES = [
    { id: '1', src: cryptoCurrencyApp, caption: 'Crypto Currency Compare', githubLink: 'https://github.com/Geenzo/VueCryptoCurrency', demoLink: 'https://www.darren-hay.com/projects/CryptoCurrency/', description: 'Small project created to try out VueJS, using two APIs for data, Cyrptocompare and Coinmarketcap Created using HTML5, CSS, JavaScript (VueJS), with 2 APIs.'},
    { id: '2', src: davidGraham, caption: 'David Graham Plumbing', githubLink: null, demoLink: 'https://www.davidgrahamplumbers.co.uk/', description: 'This was a freelance project I developed and designed for a client, Project can be found on David Graham Plumbers'},
    { id: '3', src: pokedex, caption: 'Pokedex', githubLink: 'https://github.com/Geenzo/Pokedex', demoLink: 'https://www.darren-hay.com/projects/Pokedex/', description: 'This was a freelance project I developed and designed for a client, Project I created this project to showcase my ability to use APIs, jQuery and JavaScript, This is the first draft of the project and I will be adding improvements in the future. Created using HTML5, CSS, JavaScript, jQuery and with the use of PokeApi'},
    { id: '4', src: artisanFlooring, caption: 'Artisan Hardwood Flooring', githubLink: null, demoLink: 'https://www.darren-hay.com/img/artisanflooring.png', description: 'While working at Artisan Hardwood Flooring, there was the need to advertise the business, to do so I created a poster that would be displayed on a billboard within the centre of Glasgow, this is the poster that I produced for this project Created using Adobe Photoshop'},
];


class AboutPage extends React.Component {
    render() {
        const siteTitle = "Darren Hay - Projects - Portfolio"
        const siteDescription = "This is my portfolio about page, with information about me"

        return (
            <Layout>
                <Helmet>
                        <title>{siteTitle}</title>
                        <meta name="description" content={siteDescription} />
                </Helmet>

                <div id="main">

                     <h2>Recent Work</h2>

                    <Gallery images={DEFAULT_IMAGES.map(({ id, src, thumbnail, caption, githubLink, demoLink, description }) => ({
                        src,
                        thumbnail,
                        caption,
                        githubLink,
                        demoLink,
                        description
                    }))} />

                    <ul className="actions">
                        <li><a href="/" className="button">Home</a></li>
                    </ul>

                </div>

            </Layout>
        )
    }
}

export default AboutPage